export const currentYear = new Date().getFullYear();
export const experienceYear = currentYear - 2012;
